import { render, staticRenderFns } from "./GvdAdminHeader.vue?vue&type=template&id=6da8c0d6&scoped=true"
import script from "./GvdAdminHeader.vue?vue&type=script&lang=ts"
export * from "./GvdAdminHeader.vue?vue&type=script&lang=ts"
import style0 from "./GvdAdminHeader.vue?vue&type=style&index=0&id=6da8c0d6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da8c0d6",
  null
  
)

export default component.exports